{
  "raporharitapersonel": {
    "Baslik": "Personel Harita Raporu",
    "Arama": "Arama",
    "Filtrele": "Filtrele",
    "Yenile": "Yenile",
    "Kullanici": "Kullanıcı",
    "Tarih": "Tarih",
    "Uygula": "Uygula",
    "Temizle": "Temizle",
    "Marker": "İşaretçi",
    "Polyline": "Güzergah",
    "HaritaKatmanlari": "Harita Katmanları",
    "SokakHaritasi": "Sokak Haritası",
    "UyduGoruntusu": "Uydu Görüntüsü",
    "TopografikHarita": "Topografik Harita",
    "Cap": "Çap",
    "Kapat": "Kapat"
  }
}
